
export type FeedbackStatus = "success" | "failed";
export type TimeIntervalFormat = 'minutes'|'hours'|'days';
export const TimeIntervalFormats: Record<TimeIntervalFormat, TimeIntervalFormat> = {
  minutes: "minutes",
  hours: "hours",
  days: "days"
};

export interface TimeDiff {
  value: number,
  time: TimeIntervalFormat,
  isFuture: boolean,
  fullDate: string;
}

export default interface Verification {
  id: string;
  fullName: string;
  timeAgo?: TimeDiff;
  updatedAgo?: TimeDiff;
  verified?: boolean;
  status: string;
  nationality?: string;
  gender?: string;
  birthDate?: string;
  dateOfIssue?: string;
  dateOfExpiry?: string;
  createdAgo?: TimeDiff;
  expiresIn?: string;
  isAdult?: boolean;
  image?: string;
  percentage?: number;
  createdAt?: string;
  expiresAt?: string;
  idNumber?: string;
  feedback?: {
    _id: string
    status: FeedbackStatus,
    reason: string | null
  };
  images?: {
    addBack: string;
    addFront: string;
    register?: Array<string>;
  },
  userName?: string
  ocrRaw?: string,
  barcodeRaw?: string,
  geolocation?: {
    ip?: string;
    latitude?: number;
    longitude?: number;
    country?: string;
    city?: string;
  }
}
